export const Property = (propertyData) => ({
    ...propertyData,
    isSystemProperty(){
        return propertyData.organisationId === null && propertyData.sportType === null;
    }
});
